<section class="section-card" [attr.aria-label]="cardTitle">
  <header class="section-card__header">
    <div class="section-card__heading">
      @if (iconPath) {
        <span class="section-card__icon" aria-hidden="true"><img [src]="iconPath" alt="" width="14" height="14" /></span>
      }
      <h2 class="section-card__title">{{ cardTitle }}</h2>
    </div>
    @if (caption) {
      <span class="section-card__caption">{{ caption }}</span>
    }
  </header>
  <div class="section-card__body">
    <ng-content></ng-content>
  </div>
</section>
